package io.horion.cv.pages.job.company

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.components.forms.Button
import io.horion.cv.components.forms.JobFormLayout1
import io.horion.cv.components.forms.JobFormLayout2
import io.horion.cv.components.widgets.FilterCheckGroup
import io.horion.cv.components.widgets.FormRow
import io.horion.cv.models.Job
import io.horion.cv.models.JobStatus
import io.horion.cv.utils.Colors
import io.horion.cv.utils.jobsList
import io.horion.cv.utils.label
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Page("/job/update")
@Composable
fun UpdateJob(){
    val ctx = rememberPageContext()

 /*   var colorMode by ColorMode.currentState
    LaunchedEffect(Unit) {
        val prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches

        colorMode = if (prefersDark) {
            ColorMode.DARK
        } else {
            ColorMode.LIGHT
        }
    }
    val isDark = colorMode.isDark
*/
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val id = ctx.route.params.get("id")  // Récupérer l'ID de l'URL
    var job = jobsList.find { it.id == id } ?: Job()
 //   var job by remember { mutableStateOf(Job()) }
    val breakpoint = rememberBreakpoint()
    var selectedJobStatus by remember { mutableStateOf(listOf(JobStatus.ACTIVE)) }


    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(if (!isDark) Colors.LightGray else Colors.LightDark),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header(
            breakpoint, job = job,
            isDark = isDark
        )
        Box(
            modifier = Modifier.fillMaxWidth()
                .maxWidth(1500.px)
                .padding(leftRight = 20.px)
                .margin(bottom = 20.px)
                .backgroundColor(if (isDark) Colors.holder else Colors.White),
        ) {

            Column(
                modifier = Modifier.fillMaxSize()
                    .margin(20.px),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                JobFormLayout1(
                    state = job,  // Passer l'état mutable
                    onStateChange = { job = it })

                JobFormLayout2(
                    state = job,  // Passer l'état mutable
                    onStateChange = { job = it })
                FormRow(
                    label = "Status du job",
                    breakpoint = breakpoint
                ) {
                    FilterCheckGroup(
                        title = "",
                        items = JobStatus.values().toList(),
                        checkedItems = selectedJobStatus,
                        onCheckedChange = { item, isChecked ->
                            selectedJobStatus = if (isChecked) {
                                selectedJobStatus + item
                            } else {
                                selectedJobStatus - item
                            }
                        },
                        label = { it.label() },
                        breakpoint = breakpoint
                    )
                }
            }

        }

        FormActionButton(
            onViewApplicants = {
                ctx.router.navigateTo("/job/candidatures?id=${job.id}")
            },
            onValidate = {},
            onDelete = {}
        )
    }
}
@Composable
fun FormActionButton(
    onViewApplicants: () -> Unit,
    onValidate: () -> Unit,
    onDelete: () -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(topBottom = 20.px),
        horizontalArrangement = Arrangement.spacedBy(16.px, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically
    ) {

        //  Voir candidatures
        Button(
            onClick = { onViewApplicants() },
            modifier = Modifier
                .height(42.px)
                .padding(leftRight = 18.px)
                .backgroundColor(Colors.LighterBlue)
                .color(Colors.White)
                .borderRadius(8.px)
        ) {
            Text("Candidatures")
        }

        //  Valider
        Button(
            onClick = { onValidate() },
            modifier = Modifier
                .height(42.px)
                .padding(leftRight = 18.px)
                .backgroundColor(Colors.Primary)
                .color(Colors.White)
                .borderRadius(8.px)
        ) {
            Text("Valider")
        }

        //  Supprimer
        Button(
            onClick = { onDelete() },
            modifier = Modifier
                .height(42.px)
                .padding(leftRight = 18.px)
                .backgroundColor(Colors.Red)
                .color(Colors.White)
                .borderRadius(8.px)
        ) {
            Text("Supprimer")
        }
    }
}